import { render, staticRenderFns } from "./RegistrationLearners.vue?vue&type=template&id=014fed92&scoped=true"
import script from "./RegistrationLearners.vue?vue&type=script&lang=js"
export * from "./RegistrationLearners.vue?vue&type=script&lang=js"
import style0 from "./RegistrationLearners.vue?vue&type=style&index=0&id=014fed92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014fed92",
  null
  
)

export default component.exports